import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import PublicPage from './pages/PublicPage';
import OpenInvitePage from './pages/OpenInvitePublicPage';
import { ErrorBoundary, ErrorPage } from './components/ErrorBoundary';

const HarverPage = lazy(() => import('./HarverPages'));

function App(): JSX.Element {
    return (
        <ErrorBoundary errorComponent={<ErrorPage />}>
            <Router>
                <Suspense fallback={null}>
                    <Switch>
                        <Route path="/interview/invite" component={OpenInvitePage} />
                        <Route path="/interview" component={PublicPage} />
                        <Route path="/:accountId" component={HarverPage} />
                    </Switch>
                </Suspense>
            </Router>
        </ErrorBoundary>
    );
}

export default App;
